module.exports = __webpack_public_path__ + "static/img/renwutongbu2.a49700b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/renwutongbu2.png
// module id = QitE
// module chunks = 24